var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolderSet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#60A5FA",
    fillRule: "evenodd",
    d: "M6.75 6.75h6.75C15.75 6.75 15.188 9 18 9h11.25a3.375 3.375 0 0 1 3.375 3.375V27a3.375 3.375 0 0 1-3.375 3.375H6.75A3.375 3.375 0 0 1 3.375 27V10.125A3.375 3.375 0 0 1 6.75 6.75Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M6.75 12.375h22.5a3.375 3.375 0 0 1 3.375 3.375V27a3.375 3.375 0 0 1-3.375 3.375H6.75A3.375 3.375 0 0 1 3.375 27V15.75a3.375 3.375 0 0 1 3.375-3.375Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderSet);
export default __webpack_public_path__ + "static/media/iconFolderSet.50b984e39f1ff029cf2eb1613bfcb9b7.svg";
export { ForwardRef as ReactComponent };